import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[dataColumn][key][display]',
})
export class DataColumnDirective {
  @Input()
  key!: string;
  @Input()
  display!: string;

  @Input()
  exportKey?: string;

  // For columns whose cell text is computed (badges, Ja/Nein, joined lists) —
  // takes precedence over exportKey/key path resolution in the CSV/PDF export.
  @Input()
  exportValue?: (item: any) => string;

  // Erzwingt feste Nachkommastellen im CSV/PDF-Export für Messgrößen (Fläche, Zustand),
  // damit ein runder Wert als '1.00' statt '1' exportiert wird.
  @Input()
  exportDecimals?: number;

  // Set to false on pure action/preview columns so they are omitted from CSV/PDF exports.
  @Input()
  exportable = true;

  @Input()
  sortable = true;

  constructor(public readonly template: TemplateRef<any>) {}
}
